export default {
      id: "icon-cmd-usage",
      viewBox: "0 0 48 48",
      url: "/" + "assets/sprite.svg#icon-cmd",
      toString: function () {
        return this.url;
      }
    }